import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/lib/apiClient'

/** Sprint "Corrección Final Product Experience V2" (10/09/2026, Secciones 7/8/9/10 del
 * encargo): "Administración" desde Telegram -- reutiliza ÍNTEGRAMENTE los endpoints admin ya
 * reales de `app/api/mini_app.py` (`/admin/home`, `/admin/users`, `PATCH /admin/users/
 * {id}`), nunca una segunda arquitectura administrativa. Seguridad real: `require_admin_
 * role` (backend) devuelve 403 a cualquier no-ADMIN aunque llame al endpoint directo --
 * este hook nunca es la única barrera. */

export interface AdminUser {
  id: number
  telegram_user_id: number
  telegram_username: string | null
  display_name: string | null
  role: 'ADMIN' | 'CLIENT'
  plan: string
  status: 'pending' | 'active' | 'suspended' | 'expired' | 'blocked'
  starts_at: string | null
  expires_at: string | null
  last_access_at: string | null
  created_at: string
  notes: string | null
  trial: { expired: boolean }
}

export function useAdminHome(enabled: boolean) {
  return useQuery<{ users_by_status: Record<string, number> }>({
    queryKey: ['mini-app', 'admin', 'home'],
    queryFn: async () => (await apiClient.get('/api/mini-app/admin/home')).data,
    enabled,
  })
}

export function useAdminUsers(enabled: boolean) {
  return useQuery<{ users: AdminUser[] }>({
    queryKey: ['mini-app', 'admin', 'users'],
    queryFn: async () => (await apiClient.get('/api/mini-app/admin/users')).data,
    enabled,
    staleTime: 10_000,
  })
}

export interface AdminUserUpdatePayload {
  userId: number
  role?: string
  plan?: string
  status?: string
  expires_at?: string | null
  notes?: string
}

export function useAdminUpdateUser() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ userId, ...body }: AdminUserUpdatePayload) =>
      (await apiClient.patch(`/api/mini-app/admin/users/${userId}`, body)).data,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mini-app', 'admin', 'users'] })
      queryClient.invalidateQueries({ queryKey: ['mini-app', 'admin', 'home'] })
    },
  })
}
